module.exports = __webpack_public_path__ + "assets/img/3_1206_big.78c135cc.jpg";